export const APPLICATION_STATUS = {
  INCOMPLETE: 'incomplete',
  PENDING: 'pending',
  APPROVED: 'approved',
  DENIED: 'denied',
};

export const PAYMENT_STATUS = {
  PAID: 'paid',
  UNPAID: 'unpaid',
  BALANCE_DUE: 'balance_due',
};

export const AMENITY_SPACE_STATUS = {
  ENABLED: 'enabled',
  DISABLED: 'disabled',
};
